import { render, staticRenderFns } from "./LeadAssignManager.vue?vue&type=template&id=66ef802d&scoped=true&"
import script from "./LeadAssignManager.vue?vue&type=script&lang=js&"
export * from "./LeadAssignManager.vue?vue&type=script&lang=js&"
import style0 from "./LeadAssignManager.vue?vue&type=style&index=0&id=66ef802d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ef802d",
  null
  
)

export default component.exports